import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-400);
`
